module.exports = __webpack_public_path__ + "static/front/img/logo1.14f3358b.png";